import { Box, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwFormSelect } from 'redesign';
import { TimeSlotFormContext } from './time-slot.types';

export const SegmentKindFields = ({ isCreateMode }: { isCreateMode: boolean }) => {
  const { t } = useTranslation('all-platforms-common');
  const { control, watch } = useFormContext<TimeSlotFormContext>();
  const segmentKind = watch('segmentKind');

  return (
    <FieldsWrapper>
      <LwFormSelect
        name="segmentKind"
        label={t('availability-page.sidebar.kind-label')}
        control={control}
        disabled={!isCreateMode}
        data-testid="availability-segment-kind"
        options={[
          {
            label: t('availability-page.sidebar.kind-available'),
            value: 'available',
          },
          {
            label: t('availability-page.sidebar.kind-unavailable'),
            value: 'unavailable',
          },
        ]}
      />
      {segmentKind === 'unavailable' ? (
        <LwFormSelect
          name="unavailabilityType"
          label={t('availability-page.sidebar.type-label')}
          control={control}
          data-testid="availability-unavailability-type"
          options={[
            {
              label: t('availability-page.sidebar.type-paid'),
              value: 'unavailablePaid',
            },
            {
              label: t('availability-page.sidebar.type-unpaid'),
              value: 'unavailableUnpaid',
            },
          ]}
        />
      ) : null}
    </FieldsWrapper>
  );
};

const FieldsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
